import { Modify } from 'types/modify';
import { HeaderFull, ModalWindows, SanityKeyed } from './studio';

export type RegionSelector = Modify<
  ModalWindows['region'],
  {
    _type?: 'region';
  }
>;

export enum NavigationLinkType {
  page = 'page',
  link = 'link',
  submenu = 'submenu'
}

export enum HeaderBackground {
  white = 'white',
  transparent = 'transparent'
}

export type HeaderNavLink = {
  slug?: {
    current: string;
  };
};

export type HeaderSection = SanityKeyed<HeaderFull>;
